import type { ChakraProps} from '@chakra-ui/react'
import { Box, Spinner } from '@chakra-ui/react'

export const Loading = ({ large = false, text = 'Načítání...', sx, ...rest }: { large?: boolean, text?: string } & ChakraProps) => {
  return (
    <Box
      sx={{
        display: 'grid',
        gap: 2,
        py: large ? 8 : 0,
        placeContent: 'center',
        placeItems: 'center',
        ...sx
      }}

      {...rest}
    >
      <Spinner />
      {text}
    </Box>
  )
}
